import React from "react";
// import AuthImageBox from "./AuthImageBox";
import Logo from "../assets/images/TrustSoft-white.png";
import favicon from "../assets/images/myna-white-favicon.png";

const AuthLeftSide = () => {
  return (
    <>
      {/* <div className="fixed top-4 left-4 lg:hidden bg-webPrimary py-1.5 px-2 rounded-md">
        <img src={Logo} alt="logo" width={150} height={100} />
      </div> */}
      <div className="hidden bg-muted lg:block">
        <div className="h-full w-full object-cover bg-webPrimary flex justify-end items-center flex-col relative">
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <img src={Logo} alt="logo" width={400} height={250} />
          </div>
          <div className="footer-link text-white pt-0 p-8">
            <p className="text-xs flex items-start gap-1 text-justify">
              <img
                className="small-white-favicon"
                width={20}
                height={20}
                src={favicon}
                alt=""
              />{" "}
              TrustSoft acknowledges the Traditional Custodians of country
              throughout Australia and their connections to land, sea and
              community. We pay our respect to their Elders past and present and
              extend that respect to all Aboriginal and Torres Strait Islander
              peoples today.
            </p>
            {/* <div className="pt-6">
            <AuthImageBox />
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLeftSide;
